module.exports = __webpack_public_path__ + "img/bg_duoduop_des_1.7c295acd.jpg";